var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadComponent)?_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"loading"},[_c('circle-spin')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }